<template>
  <v-layout id="screen-log">
    <div>
      <div
        :style="{
          width: this.content.width + 'px',
          height: this.content.height + 'px',
        }"
        ref="contentRef"
      >
        <div class="content">
          <!-- JXCEL -->
          <div
            v-if="
              user != null &&
              this.content.width != 0 &&
              this.content.height != 0 &&
              this.dataJexcel != null
            "
          >
            <Jexcel
              :key="childComponent"
              v-bind:user="this.user"
              v-bind:widthJexcel="this.content.width"
              v-bind:heightJexcel="this.content.height"
              v-bind:dataSet="this.dataJexcel"
              v-bind:conf="onglet"
              v-on:event-dispatcher="eventDispatch"
              v-on:message-response="toasterThrow"
              v-on:json-jexcel="sendModifiation"
            />
          </div>
        </div>
      </div>
    </div>

    <div v-if="this.processing">
      <v-overlay :z-index="zIndex" :value="overlay"
        ><spinner
          class="spinner-tab"
          :message="messageSpinner"
          :displayInfos="false"
      /></v-overlay>
    </div>
  </v-layout>
</template>

<script>
import Spinner from '@/components/AppSpinner';
import Jexcel from '@/components/jExcelTable/jExcel';
import ConfOnglet from './ConfOngletsModifScenario';
export default {
  components: {
    Spinner,
    Jexcel,
  },
  props: ['user', 'ongletIndex'],
  data: function () {
    return {
      dataJexcel: null,
      childComponent: 0,
      search: '',
      onglet: null,
      processing: false,
      documentHeight: 0,
      documentWidth: 0,
      messageSpinner: '',
      overlay: true,
      zIndex: 9999,
      content: {
        width: 0,
        height: 0,
      },
    };
  },
  methods: {
    async initData() {
      this.onglet = ConfOnglet[this.ongletIndex];
      const data = await this.getData();
      this.dataJexcel = data;
      this.setConstantes();
      this.setEvents();
    },
    getData() {
      this.processing = true;
      this.messageSpinner = 'Chargement données';
      let proc = this.onglet['procedureJexcel'];
      return axios({
        method: 'get',
        url:
          process.env.VUE_APP_BASE_URL +
          process.env.VUE_APP_MODIF_SC_GET_JEXCEL_DATA_RIGHT_TAB,
        headers: {
          'Content-Type': 'application/json',
          user: this.user.email,
        },
        params: {
          inId: 0,
          type: 0,
          procedureName: proc,
        },
      })
        .then((response) => {
          this.processing = false;
          return response.data;
        })
        .catch((error) => {
          this.processing = false;
          this.$emit(
            'message-response',
            "Erreur serveur lors du chargement de l'onglet",
            -1,
            true,
            9000
          );
        });
    },
    async sendModifiation(objet) {
      this.processing = true;
      var proc = this.onglet['procedureModifBdd'];
      this.messageSpinner = 'Prise en compte de vos modifications en cours';
      let json = JSON.stringify(objet);
      let flagError = false;
      let flagStatus;
      await axios({
        method: 'post',
        url: process.env.VUE_APP_BASE_URL + process.env.VUE_APP_MODIF_SC_POST,
        headers: {
          'Content-Type': 'application/json',
          user: this.user.email,
        },
        data: {
          jsonIn: json,
          procedureName: proc,
        },
      })
        .then((response) => {
          flagStatus = response.data.status;

          this.$emit(
            'message-response',
            response.data.message,
            response.data.status,
            true,
            600000
          );
        })
        .catch((error) => {
          flagError = true;
          this.$emit(
            'message-response',
            'Erreur du serveur lors de la modification des données',
            -1,
            true,
            9000
          );
        })
        .finally(() => {
          this.$store.dispatch('fetchUserInfos');
        });

      if (!flagError && flagStatus == 1) {
        await this.initData()
        this.childComponent +=1 ;
      }

      this.processing = false;
    },
    eventDispatch(event, data) {
      if (event == 'message-response') {
        this.toasterThrow(data[0], data[1], data[2], data[3]);
      } else {
        this.sendModifiation(data[0]);
      }
    },
    toasterThrow(message, status, flag, timeout) {
      this.$emit('message-response', message, status, flag, timeout);
    },
    onWindowsResize(e) {
      this.updateConstantes();
    },
    updateConstantes() {
      this.documentWidth = window.innerWidth;
      this.documentHeight = window.innerHeight;
      this.content.width = this.documentWidth - (this.documentHeight*0.064);
      this.content.height = this.documentHeight - (this.documentHeight*0.33);
    },
    setConstantes() {
      this.documentWidth = window.innerWidth;
      this.documentHeight = window.innerHeight;
      this.content.width = this.documentWidth - (this.documentHeight**0.064);
      this.content.height = this.documentHeight - (this.documentHeight*0.33);
    },
    setEvents() {
      const contentelement = this.$refs['contentRef'];

      window.addEventListener('resize', this.onWindowsResize);
    },
    waitResolveSeconds(millsec) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve('resolved');
        }, millsec);
      });
    },
  },
  async created() {
    await this.initData();
  },
};
</script>

<style>
.noWidth {
  width: 0;
}

.scdf-yellow {
  margin-top: 10px;
}

.spinner-tab {
  margin-top: 30px;
}

.v-text-field {
  padding-right: 10px;
}

.content {
  padding-top: 10px;
  padding-left: 10px;
  padding-bottom: 10px;
}

.sidetab-content {
  padding-top: 10px;
  padding-left: 10px;
  padding-bottom: 10px;
}

.choice-message {
  color: black;
}

.dialog {
  z-index: 99999;
}

.suggestion {
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  position: relative;
}
</style>